import {
  all,
  call,
  fork,
  put,
  takeEvery,
  takeLatest,
} from "redux-saga/effects";
import { fetchData } from "../services/api";
import {
  TOASTER_SHOW,
  TOASTER_HIDE,
  LOADER_SHOW,
  LOADER_HIDE,
} from "../constant";
export function* sagaRoot(payload) {
  const { type, hideOverlayLoader, hideSuccessToaster } = payload.payload;
  const showOverlayLoader = hideOverlayLoader ? !hideOverlayLoader : true;
  // Silent success for on-load GETs (e.g. profile, vehicle list) — use page loading UI instead.
  const suppressSuccessToast =
    hideSuccessToaster || type === "BRANDS";
  yield put({ type: `${type}_REQUEST` });
  try {
    if (showOverlayLoader) yield put({ type: LOADER_SHOW });
    const response = yield call(fetchData, payload);

    if (response.message.type === "success") {
      yield put({
        type: `${type}_SUCCESS`,
        payload: response.data,
        message: response.message,
      });
      yield put({ type: LOADER_HIDE });
      if (!suppressSuccessToast) {
        yield put({ type: TOASTER_SHOW, payload: response.message });
      }
    } else if (response.message.type === "error") {
      yield put({ type: `${type}_FAIL`, payload: response.data });
      yield put({ type: LOADER_HIDE });
      yield put({ type: TOASTER_SHOW, payload: response.message });
    }
    return { ...response, bodyData: payload.payload };
  } catch (error) {
    yield put({ type: `${type}_ERROR`, payload: error });
    yield put({ type: LOADER_HIDE });
    yield put({
      type: TOASTER_SHOW,
      payload: {
        show: true,
        autoHide: true,
        type: "error",
        description:
          error?.message ||
          "Unable to reach the server. Please try again.",
      },
    });
  }
}
